export class BiometryFingerPrintActiveRequest {
    codeSecurity: string;

    constructor(codeSecurity: string) {
        this.codeSecurity = codeSecurity;
    }
}